'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Media = require('./Media.css');

var _Media2 = _interopRequireDefault(_Media);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Media = (_dec = (0, _reactCssModules2.default)(_Media2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Media, _Component);

  function Media(props) {
    (0, _classCallCheck3.default)(this, Media);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Media.__proto__ || (0, _getPrototypeOf2.default)(Media)).call(this, props));

    _this.pressHits = [{
      outlet: 'The New York Times',
      headline: 'Funds That Can Put Your Investments on a Low-Carbon Diet',
      link: 'https://www.nytimes.com/2017/10/13/business/mutfund/mutual-funds-low-carbon.html'
    }, {
      outlet: 'The Guardian',
      headline: 'The Carbon Bubble: Why Investors Can No Longer Ignore Climate Risks',
      link: 'https://www.theguardian.com/sustainable-business/2016/oct/27/investment-advice-retirement-portfolio-tips-climate-change-financial-risk'
    }, {
      outlet: 'The Dodo',
      headline: 'Here Are Some Easy Ways To Protect Animals From Climate Change',
      link: 'https://www.thedodo.com/5-things-fight-climate-change-2103743992.html'
    }, {
      outlet: 'Bill Moyers and Company',
      headline: 'Climate Action Is Up to the Rest of Us Now',
      link: 'http://billmoyers.com/story/climate-action-rest-us-now/'
    }, {
      outlet: 'ThinkProgress',
      headline: 'The World Agreed To Not Burn Most Fossil Fuels. Why Aren’t These Banks Listening?',
      link: 'http://thinkprogress.org/climate/2016/06/15/3788310/shorting-the-climate-bank-report/'
    }, {
      outlet: 'TriplePundit',
      headline: '5 Ways Your Personal Investments Can Help Solve Climate Change',
      link: 'http://www.triplepundit.com/2016/05/5-ways-personal-investments-can-help-solve-climate-change/'
    }, {
      outlet: 'Co.Exist',
      headline: 'How To Convince Your Employer To Divest Your 401(k) From Fossil Fuels',
      link: 'http://www.fastcoexist.com/3059618/how-to-convince-your-employer-to-divest-your-401k-from-fossil-fuels'
    }, {
      outlet: 'Bloomberg BNA',
      headline: 'GE, Microsoft Urged to Offer Fossil-Fuel-Free 401(k)s',
      link: 'http://www.bna.com/ge-microsoft-urged-n57982069981/'
    }, {
      outlet: 'ThinkProgress',
      headline: 'There’s Now A Way To Find Out How Much Of Your Retirement Is Invested In Fossil Fuels',
      link: 'http://thinkprogress.org/climate/2015/09/17/3702007/fossil-free-funds-tool/'
    }, {
      outlet: 'Grist',
      headline: 'Looking for a Fossil Free Investment Fund? Check the Fine Print',
      link: 'http://grist.org/business-technology/looking-for-a-fossil-free-investment-fund-check-the-fine-print/'
    }, {
      outlet: 'Earth Island Journal',
      headline: 'Follow the Money: The Fossil Fuels Divestment Movement is Making Big Strides, But Individual Investors Have Little Way of Knowing What They Own',
      link: 'http://www.earthisland.org/journal/index.php/elist/eListRead/follow_the_money/'
    }, {
      outlet: 'Financial Advisor',
      headline: 'Unearthing The Fossil Fuels In Mutual Funds',
      link: 'http://www.fa-mag.com/news/unearthing-the-fossil-fuels-in-mutual-funds-23685.html'
    }, {
      outlet: 'EcoWatch',
      headline: 'Is Your Retirement Invested in Fossil Fuels?',
      link: 'http://ecowatch.com/2015/09/15/retirement-invested-fossil-fuels/'
    }, {
      outlet: 'Mother Nature Network',
      headline: 'Are You Invested in Fossil Fuels? A New Web Tool Helps Investors Figure Out Exactly Where Their Money Is',
      link: 'http://www.earthisland.org/journal/index.php/elist/eListRead/follow_the_money/'
    }];

    _this.clickViewMore = function (release) {
      var newState = {};
      newState[release] = !_this.state[release];
      _this.setState(newState);
    };

    _this.renderButton = function (label, title, date, subtitle, renderFn) {
      var btnLabel = !_this.state[label] ? 'View the Full Release' : 'View Less';
      return _react2.default.createElement(
        'div',
        { styleName: 'press-release-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'press-release-title' },
          title
        ),
        _react2.default.createElement(
          'p',
          null,
          date,
          ' \u2014 ',
          subtitle
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'press-release-button', onClick: function onClick() {
              return _this.clickViewMore(label);
            } },
          _react2.default.createElement('i', { className: _this.state[label] ? 'fa fa-caret-down' : 'fa fa-caret-right' }),
          '\xA0 \xA0 \xA0',
          btnLabel
        ),
        _this.state[label] ? renderFn() : null
      );
    };

    _this.renderReleaseMacroclimateButton = function () {
      var label = 'macroclimate';
      var title = '$11 Trillion in Fund Holdings Screened for 50 Largest Coal-Fired Utilities';
      var date = 'Apr. 24, 2017';
      var subtitle = "As You Sow's Fossil Free Funds partners with Macroclimate® to expose hidden investments in coal power plants";
      var renderFn = function renderFn() {
        return _this.renderReleaseMacroclimate();
      };

      return _this.renderButton(label, title, date, subtitle, renderFn);
    };

    _this.renderReleaseFootprintButton = function () {
      var label = 'footprint';
      var title = 'New Web Tool Shows Unexpectedly High Carbon Exposure of Funds';
      var date = 'Oct. 13, 2016';
      var subtitle = 'As You Sow, YourSRI.com team up to carbon footprint $11 trillion in funds utilizing data from South Pole Group and exposing carbon risk – available now at fossilfreefunds.org';
      var renderFn = function renderFn() {
        return _this.renderReleaseFootprint();
      };

      return _this.renderButton(label, title, date, subtitle, renderFn);
    };

    _this.renderReleaseRetirementPlansButton = function () {
      var label = 'retirementPlans';
      var title = 'More than 20,000 Individual and 401(k) Investors Call for Fossil Free Retirement Options';
      var date = 'Apr. 18, 2016';
      var subtitle = 'Many Americans are increasingly worried about the financial risk of owning fossil fuel companies in their 401(k) plans';
      var renderFn = function renderFn() {
        return _this.renderReleaseRetirementPlans();
      };

      return _this.renderButton(label, title, date, subtitle, renderFn);
    };

    _this.renderReleaseLaunchButton = function () {
      var label = 'launch';
      var title = 'New Web Tool Reveals Fossil Fuel Companies Hidden in Mutual Funds';
      var date = 'Sep. 15, 2015';
      var subtitle = 'New, free-to-the-public web tool reveals where fossil fuel holdings are hiding in the most commonly-owned mutual funds';
      var renderFn = function renderFn() {
        return _this.renderReleaseLaunch();
      };

      return _this.renderButton(label, title, date, subtitle, renderFn);
    };

    _this.renderReleaseMacroclimate = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'release-wrap' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Oakland, CA \u2013 April 24, 2017'
          ),
          ' - Fossil Free Funds and Macroclimate',
          _react2.default.createElement(
            'sup',
            null,
            _react2.default.createElement(
              'small',
              null,
              '\xAE'
            )
          ),
          ' have combined forces to expand the ',
          _react2.default.createElement(
            'a',
            { href: '/macroclimate-50', title: 'Macroclimate 50 - Fossil Free Funds - a project of As You Sow' },
            _react2.default.createElement(
              'strong',
              null,
              'FossilFreeFunds.org'
            )
          ),
          ' platform with brand new research, highlighting investments in 50 of the largest, most carbon-intensive coal-fired utilities. This new addition to the financial transparency platform enables investors, including large institutions, to better measure the climate risk embedded in their portfolio. The site uses up-to-date mutual fund holdings to search for investments in fossil fuel companies, and aggregates the overall carbon footprint of each fund so that they can be compared, smokestack to smokestack.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Fossil Free Funds is offered by As You Sow, a climate watchdog group focused on empowering every shareholder to align their values with their investments by shining a light on which companies each of us actually owns. Many experts say ',
          _react2.default.createElement(
            'a',
            { href: 'https://macroclimate.com/coal', target: '_blank', title: '' },
            _react2.default.createElement(
              'strong',
              null,
              'coal is the #1 problem'
            )
          ),
          ' in the fight against climate change. By incorporating Macroclimate\'s research into Fossil Free Funds\' transparency platform, investors have a new lens into how their savings are being invested into companies contributing to climate catastrophe.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '"Measuring how many of your hard-earned dollars are invested in coal-fired power is a critical step in understanding the specific climate impact and risk of your investments," said Andrew Behar, CEO of As You Sow. "We are helping investors large and small align their investing with their values and use the power of their capital to create a clean energy future."'
        ),
        _react2.default.createElement(
          'p',
          null,
          '"Financial self-interest alone is sufficient to drive the behavior of mainstream investors," said Mark Kriss, Managing Partner at ',
          _react2.default.createElement(
            'a',
            { href: 'https://macroclimate.com/about', target: '_blank', title: '' },
            _react2.default.createElement(
              'strong',
              null,
              'Macroclimate',
              _react2.default.createElement(
                'sup',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  '\xAE'
                )
              )
            )
          ),
          '. "Even with Trump, the expected financial impact of excluding coal power plants \u2013 and other fossil fuel assets \u2013 is neutral to positive for long-term investors using well-constructed portfolios."'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The groups found over $196 Billion in direct stock investments by U.S. equity funds in Macroclimate',
          _react2.default.createElement(
            'sup',
            null,
            _react2.default.createElement(
              'small',
              null,
              '\xAE'
            )
          ),
          ' 50 companies. However, ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.asyousow.org/macroclimate-blog', target: '_blank', title: 'Your Hard-Earned Dollars, Invested in Climate-Killing Coal\xA0Power | As You Sow Blog' },
            _react2.default.createElement(
              'strong',
              null,
              'not all asset managers were equally exposed'
            )
          ),
          ' \u2013 of the 20 largest managers of equity funds, SPDR State Street Global Advisors had the most overall exposure to the list of coal-fired utilities. Of those same 20 managers, Dodge & Cox was alone in having no direct stock investments in the Macroclimate',
          _react2.default.createElement(
            'sup',
            null,
            _react2.default.createElement(
              'small',
              null,
              '\xAE'
            )
          ),
          ' 50.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Fossil Free Funds analyzes thousands of the most commonly held open-end and exchange-traded mutual funds found in U.S. retirement plans. '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            '# # #'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'ABOUT THE ORGANIZATIONS:'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'As You Sow'
          ),
          ' is a nonprofit organization that promotes environmental and social corporate responsibility through shareholder advocacy, coalition building, and innovative legal strategies. For more information visit ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.asyousow.org', title: 'asyousow.org', target: '_blank' },
            'www.asyousow.org'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Macroclimate',
            _react2.default.createElement(
              'sup',
              null,
              _react2.default.createElement(
                'small',
                null,
                '\xAE'
              )
            )
          ),
          ' is a new kind of investment company: one that uses financial science, expert opinions of climate scientists, and state-of-the-art automation technology to help the general public invest better \u2014 in an environmentally-responsible way. For more information visit ',
          _react2.default.createElement(
            'a',
            { href: 'https://macroclimate.com/about', target: '_blank', title: 'macroclimate.com' },
            'macroclimate.com'
          ),
          '.'
        )
      );
    };

    _this.renderReleaseFootprint = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'release-wrap' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'OAKLAND, CA, ZURICH & VADUZ, LIECHTENSTEIN - OCTOBER 13, 2016'
          ),
          ' - Do mutual funds and ETF providers that talk the talk about being low carbon actually walk the walk when it comes to their portfolio?'
        ),
        _react2.default.createElement(
          'p',
          null,
          'A first-ever analysis of over $11 trillion in global mutual funds and ETFs shows that a large number of major fund families are "carbon hypocrites" that preach the merits of low-carbon investing but actually have above-average carbon holdings. The results are available at FossilFreeFunds.org, which was created by the nonprofit As You Sow and utilizes data from global sustainability solutions provider South Pole Group and yourSRI.com, which is a leading carbon data analyst and reporting solution provider for responsible investments. The site also highlights 58 socially responsible funds with no fossil fuels and very low footprints.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'All of the top 10 asset managers, accounting for 60% of the analyzed assets, have an average carbon footprint higher than the S&P 500 benchmark.'
        ),
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Asset manager'
              ),
              _react2.default.createElement(
                'th',
                null,
                'Percent difference of avg. fund footprint from S&P 500 benchmark*'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Dimensional Fund Advisors'
              ),
              _react2.default.createElement(
                'td',
                null,
                '161% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'SPDR State Street Global Advisors'
              ),
              _react2.default.createElement(
                'td',
                null,
                '141% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'iShares'
              ),
              _react2.default.createElement(
                'td',
                null,
                '123% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Franklin Templeton Investments'
              ),
              _react2.default.createElement(
                'td',
                null,
                '99% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'MFS'
              ),
              _react2.default.createElement(
                'td',
                null,
                '70% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Vanguard'
              ),
              _react2.default.createElement(
                'td',
                null,
                '65% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'JPMorgan'
              ),
              _react2.default.createElement(
                'td',
                null,
                '53% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Fidelity Investments'
              ),
              _react2.default.createElement(
                'td',
                null,
                '24% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'American Funds'
              ),
              _react2.default.createElement(
                'td',
                null,
                '11% higher'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'T. Rowe Price'
              ),
              _react2.default.createElement(
                'td',
                null,
                '7% higher'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement(
              'em',
              null,
              '* Index approximated using SPDR S&P 500 ETF'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          '"If it is true that sunshine is the best disinfectant, then this long-overdue transparency breakthrough can clean up the practices of fund managers and give investors real reason to think about what they are part of," said Andrew Behar, CEO of As You Sow. "Transparency leads to transformation, and that is what this platform is all about.  This is a way for individual and institutional investors to learn if they are unwittingly investing in their own destruction."'
        ),
        _react2.default.createElement(
          'p',
          null,
          '"A growing body of evidence suggests that the transition to a global, low-carbon economy is accelerating. Investors now have unprecedented opportunities and risks to manage across their portfolios," said Stephen Scofield, director of Financial Industry Solutions, North America, South Pole Group. "We are proud to work with As You Sow and our partners at yourSRI to put institutional-grade greenhouse emissions datasets and portfolio analytics at the fingertips of all investors and their financial advisors."'
        ),
        _react2.default.createElement(
          'p',
          null,
          '"Until now, getting objective information about carbon emissions in the capital markets has been time-consuming and difficult for most investors," said Christoph Dreher, executive partner at CSSP, the parent company of yourSRI.com. "And with the increased interest in carbon footprinting, transparency is more than just a phrase. So offering access to a standardized, cost-efficient as well as independent online solution will become a key factor for investors in the future."'
        ),
        _react2.default.createElement(
          'p',
          null,
          'How does the new online tool work? Measuring a company\'s carbon emissions is a critical way to understand the specific carbon exposure of your investments.  With the new tool, this data has been aggregated for all of the companies embedded in each of the 6,500 most-held global mutual funds and ETFs. Each fund may have hundreds of companies, each with a unique carbon footprint. Each company\'s carbon footprint is added together and then divided by the fund dollar value to display carbon per dollar. '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Three funds offered by major asset managers illustrate the importance of carbon footing:'
        ),
        _react2.default.createElement(
          'ol',
          null,
          _react2.default.createElement(
            'li',
            null,
            'Given that BlackRock recently published a major report on portfolio climate risk, it may be a surprise that the ',
            _react2.default.createElement(
              'a',
              { href: 'https://fossilfreefunds.org/funds/FSUSA001KK/FOUSA00DQF/MABAX#1', target: '_blank', title: 'BlackRock Basic Value Fund - Fossil Free Funds' },
              'BlackRock Basic Value Fund\'s (MABAX)'
            ),
            ' has a carbon footprint 170% higher than its benchmark, the Russell 1000 Value Index.'
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { href: 'https://fossilfreefunds.org/funds/FS00009PK7/F00000OPQZ/DSCLX#1', target: '_blank', title: 'Dimensional Social Core Equity' },
              'Dimensional Social Core Equity (DSCLX)'
            ),
            ' has 85% more carbon than the MSCI All World Index with 13% of the portfolio made up of fossil fuel companies including Shell, BP, and tar sands giant Suncor.'
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { href: 'https://fossilfreefunds.org/funds/FS0000C3K4/F00000WAP7/SPYX#1', target: '_blend', title: 'SPDR S&P 500 Fossil Fuel Reserves Free ETF' },
              'State Street S&P 500 Fossil Fuel Free (SPYX)'
            ),
            ' holds 40 fossil fuel companies including coal fired utilities Duke Energy and Southern Company, as well as companies with reserves like Phillips66 and oil field services leader Halliburton. '
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'The launch unveiled today covers funds in the ',
          _react2.default.createElement(
            'a',
            { href: 'https://fossilfreefunds.org/funds#us', target: '_blank', title: 'Search US Funds - Fossil Free Funds' },
            'US'
          ),
          ', ',
          _react2.default.createElement(
            'a',
            { href: 'https://fossilfreefunds.org/funds#uk', target: '_blank', title: 'Search UK Funds - Fossil Free Funds' },
            'UK'
          ),
          ', ',
          _react2.default.createElement(
            'a',
            { href: 'https://fossilfreefunds.org/funds#de', target: '_blank', title: 'Search German Funds - Fossil Free Funds' },
            'Germany'
          ),
          ', ',
          _react2.default.createElement(
            'a',
            { href: 'https://fossilfreefunds.org/funds#fr', target: '_blank', title: 'Search French Funds - Fossil Free Funds' },
            'France'
          ),
          ', ',
          _react2.default.createElement(
            'a',
            { href: 'https://fossilfreefunds.org/funds#dk', target: '_blank', title: 'Search Denmark Funds - Fossil Free Funds' },
            'Denmark'
          ),
          ', and ',
          _react2.default.createElement(
            'a',
            { href: 'https://fossilfreefunds.org/funds#hk', target: '_blank', title: 'Search Hong Kong Funds - Fossil Free Funds' },
            'Hong Kong'
          ),
          '. The developers plan to expand to cover every fund in every exchange across the entire globe soon. Carbon footprinting turns the focus to current greenhouse gas emissions, helping highlight businesses who operate with lower footprints than their industry peers. '
        ),
        _react2.default.createElement(
          'p',
          null,
          '"Decarbonizing" a portfolio involves investing in companies that have lower carbon footprints than their peers. Institutional investors such as California\'s CalPERS and ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.ap4.se/en/esg/climate-change-a-focus-area/ap4s-carbon-footprint/', title: 'AP4\'s carbon footprint', target: '_blank' },
            'Sweden\'s AP4'
          ),
          ' have embraced carbon footprinting as part of the way to protect their assets from climate risk. Major index providers are increasingly offering low-carbon options that incorporate a footprinting analysis. By providing a lens for investors to look at carbon demand and consider the entire value chain when measuring climate impact, the data can help investors large and small align their investing with their values. Fossil Free Funds analyzes over 6,500 global mutual funds, including 3,000 of the most commonly-held funds in U.S. retirement plans.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '"If you move your savings into funds with smaller footprints, that\'s a way to avoid climate risk," said Andrew Montes, Director of Digital Strategies at As You Sow. "It\'s also actively rewarding companies that have made positive decisions to lower the climate impact of their operations. Investor demand will drive fund managers to drop companies with high carbon footprints and include those companies that are shifting to the clean energy economy. A declining fund carbon footprint over time can be testimony to such an effort."'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            '# # #'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'ABOUT THE ORGANIZATIONS:'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'As You Sow'
          ),
          ' is a nonprofit organization that promotes environmental and social corporate responsibility through shareholder advocacy, coalition building, and innovative legal strategies. For more information visit ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.asyousow.org', title: 'asyousow.org', target: '_blank' },
            'www.asyousow.org'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'South Pole Group'
          ),
          ' is a leading provider of global sustainability solutions and a pioneer in emission reductions, renewable energy, supply chain, investment climate impact, forestry, and sustainable cities projects and programs. For more information visit ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.thesouthpolegroup.com/', target: '_blank', title: 'http://www.thesouthpolegroup.com/' },
            'www.thesouthpolegroup.com'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'youSRI.com & CSSP:'
          ),
          ' With its online platform yourSRI.com, CSSP helps asset managers and asset owners worldwide to adequately manage risks related to ESG and Carbon issues. yourSRI offers you an independent and comprehensive "all-in-one" solution, by partnering with a global network of service and data providers such as MSCI and South Pole Group. For more information visit ',
          _react2.default.createElement(
            'a',
            { href: 'https://yoursri.com/', target: '_blank', title: 'yourSRI.com' },
            'https://yoursri.com'
          ),
          '.'
        )
      );
    };

    _this.renderReleaseRetirementPlans = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'release-wrap' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'APRIL 18, 2016'
          ),
          ' \u2013 This tax day, millions of Americans will gain a little tax benefit and a measure of peace of mind by making an extra contribution to their retirement plan. But many Americans are increasingly worried about the financial risk of owning fossil fuel companies in their 401(k) plans. Over 20,000 people recently signed an ',
          _react2.default.createElement(
            'a',
            { href: 'http://salsa4.salsalabs.com/o/51199/p/dia/action3/common/public/?action_KEY=17835', target: '_blank' },
            _react2.default.createElement(
              'strong',
              null,
              'online petition'
            )
          ),
          ' calling on American firms to offer fossil free 401(k) options.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'A growing coalition of progressive leaders \u2013 led by Divest Invest Individual, Environmental Action, Fossil Free Funds, and HIP (Human Impact + Profit) Investor, with support from Green America, Roots Action, and The Other 98% \u2013 warns investors that 401(k) plans which rely on fossil fuel investments threaten the future of our planet and could jeopardize the long-term returns that retirees expect. American workers have more than $4.4 trillion invested in 401(k)s and similar retirement plans.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CCoal, oil, and gas are increasingly risky investments, particularly for people on fixed incomes,\u201D said Vanessa Green, Director of Divest Invest Individual, a campaign engaging accredited and retail investors in fossil fuel divestment and sustainable reinvestment. \u201CThe demand for lower risk fossil free options is there,\u201D Green continued. \u201CIn just three weeks, tens of thousands of employees in big corporations, small businesses, educational and other institutions responded to the call for those options from employers.\u201D '
        ),
        _react2.default.createElement(
          'p',
          null,
          'But the largest 401(k) plans offer few to no options for employees desiring a socially responsible portfolio free of oil, gas and coal producers. An analysis by Fossil Free Funds, an online tool that measures the climate risk of mutual funds, found only one option in the 100 largest public company 401(k)s that is both a socially responsible investment and free of the top 200 coal and oil/gas reserve holders. '
        ),
        _react2.default.createElement(
          'p',
          null,
          'As Peabody Coal files for bankruptcy and ExxonMobil spends more on its ',
          _react2.default.createElement(
            'a',
            { href: 'http://finance.yahoo.com/news/long-exxon-mobils-dividend-survive-213602133.html', target: '_blank' },
            _react2.default.createElement(
              'strong',
              null,
              'dividends'
            )
          ),
          ' than its current cash flow, the financial risks associated with fossil fuel investments increases. \u201CIf your 401(k) portfolio invests in fossil fuel producers, then your retirement nest egg could suffer higher risk and potentially lower returns,\u201D says R. Paul Herman, CEO of HIP (Human Impact + Profit) Investor, which rates 15,000 stocks, bonds and mutual funds, and advises investors and 401(k)s on how to realize higher impact portfolios. \u201C401(k) fiduciaries need to focus on the forward-looking risks of the funds their firm is offering, and seek to add funds with cleaner energy solutions for the 21st century.\u201D '
        ),
        _react2.default.createElement(
          'p',
          null,
          'For smaller, high-growth firms, like ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.stok.com/', target: '_blank' },
            _react2.default.createElement(
              'strong',
              null,
              'stok'
            )
          ),
          ', a consulting firm that focuses on strategy, performance, and sustainability in the built environment, employees and owners are already benefiting from fossil free and socially responsible mutual fund choices that align with their corporate mission. "Investing in fossil free portfolios is putting my money where my mouth is," said Kristen Magnuson, a stok employee. "It represents my optimism about our ability to achieve a clean energy future." '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Gundersen Health System, which operates a large network of hospitals and medical clinics across 19 counties in Wisconsin, Iowa, and Minnesota and ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.wbjournal.com/article/20150413/PRINTEDITION/150419988', target: '_blank' },
            _react2.default.createElement(
              'strong',
              null,
              'sets the industry\u2019s green standard'
            )
          ),
          ', recognizes a responsibility for community health inside and outside their walls. "We have frozen all our investments in organizations that produce fossil fuels and offer our employees a retirement option with companies with socially responsible characteristics," said Mark Platt, Senior Vice President of Business Services. "We\u2019ve made a commitment to renewable sources of energy that are both sustainable and lower the level of harmful emissions."'
        ),
        _react2.default.createElement(
          'p',
          null,
          'U.S. Secretary of Labor Thomas E. Perez recently ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.dol.gov/opa/media/press/ebsa/ebsa20152045.htm', target: '_blank' },
            _react2.default.createElement(
              'strong',
              null,
              'issued new guidelines in October 2015'
            )
          ),
          ' for economically-targeted investments (ETIs), which include considering environmental risks and opportunities, in retirement plans, and said, "Investing in the best interests of a retirement plan and in the growth of a community can go hand in hand.\u201D '
        ),
        _react2.default.createElement(
          'p',
          null,
          'A number of high-profile institutions and individuals have committed to divest from fossil fuels, including Rockefeller Brothers Fund, actor Leonardo DiCaprio, CalPERS and CalSTRS, Norway\u2019s KLP pension fund, and ',
          _react2.default.createElement(
            'a',
            { href: 'http://gofossilfree.org/commitments/', target: '_blank' },
            _react2.default.createElement(
              'strong',
              null,
              'others managing a combined $3.4 trillion in assets.'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CCoal companies are going bankrupt and coal CEOs are going to jail. Oil prices have flatlined, and Exxon is under investigation,\u201D said Drew Hudson, Director of Environmental Action. "You don\u2019t have to be a Rockefeller to see the writing on the wall \u2013 fossil fuels are over and American retirees shouldn\u2019t be left holding the bag.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CA growing number of Americans want to be part of climate solutions and want to shift their support away from the fossil fuel industry. Employers can do their part by offering their employees the option of investing in socially responsible mutual funds that screen out fossil fuels and support a sustainable economy,\u201D said Fran Teplitz, Executive Co-Director for Business, Investing & Policy with Green America.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CClimate risk in our pensions and retirement plans can\'t be ignored as we justly transition to a climate-safe economy,\u201D said Joe Uehlein, Executive Director of the Labor Network for Sustainability, a group engaging unions and others from the labor movement in climate issues and educating the environmental movement about jobs issues.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CClimate change caused primarily by use of fossil fuels will impact my children and my grandchildren and generations beyond them,\u201D said petition signer R. Warren Langley, who is also a former president of the Pacific Stock Exchange. \u201CWe must empower people today to take any action they can to change what past generations have ignored. Being able to \u2018vote\u2019 with your investment choices is the best way to let us all make a difference.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CMany investors are only now becoming aware that they can match their investments with their desire to protect the environment,\u201D said petition signer Kelly Guncheon, an investment adviser in Minnesota serving clients seeking to go fossil-free. \u201COften the 401(k) plan is your only portfolio. Engaging environmentally aware employees with an option to invest their 401(k) money in fossil-free portfolios is enormously satisfying.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CA fossil-free financial portfolio is important to me for value and values. It protects the value of my investments by reducing risk in a carbon-constrained world and it aligns my investments with my values by not supporting companies moving the world toward climate catastrophe,\u201D said petition signer Ron Roman, a professor at San Jose State University.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CFossil fuels are overvalued when you look at the big picture. As prudent fiduciaries, we invest in long-term solutions because we aim to be part of the solution, not part of the problem,\u201D said petition signer Ben Bingham, author of Making Money Matter, and an investment adviser.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The petition was supported by all coalition partners during the final weeks of tax season, from March 28 through April 11. It has gathered over 20,700 signatures which will be delivered to the companies offering the 100 largest retirement plans in the U.S. Organizers intend to follow up with petition signers interested in garnering support for fossil free and sustainable retirement options at their places of work.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            '# # #'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'ABOUT THE ORGANIZATIONS:'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Divest Invest Individual'
          ),
          ' - A dynamic movement of individual investors who are personally divesting from fossil fuels and leveraging their financial assets to build the new infrastructure, products, and services we need for a sustainable, equitable, clean energy economy. We join and support the growing movement among universities, municipalities, pension funds and religious denominations who recognize that this is an unprecedented opportunity to invest for both financial performance and public good. For more information, visit ',
          _react2.default.createElement(
            'a',
            { href: 'http://divestinvest.org/individual/', target: '_blank' },
            _react2.default.createElement(
              'strong',
              null,
              'divestinvest.org/individual'
            )
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Fossil Free Funds'
          ),
          ' - Fossil fuel investments carry real financial risks. With Fossil Free Funds, you can look up mutual funds and see their exposure to various fossil fuel companies. Brought to you by As You Sow, with financial data provided by Morningstar. For more information, visit ',
          _react2.default.createElement(
            'a',
            { href: 'https://fossilfreefunds.org' },
            _react2.default.createElement(
              'strong',
              null,
              'fossilfreefunds.org'
            )
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'HIP Investor'
          ),
          ' - Founded in 2006, HIP (Human Impact + Profit) Inc. rates more than 18,000 investments (nearly 5,000 companies, 12,000 muni bond issuers, 1000s of mutual funds) on their future risk, return potential and net benefit to society. HIP also advises investors, wealth managers, fund managers and 401(k) retirement plans on how portfolios can pursue "doing good" and "doing well" at the same time. HIP-weighted portfolios can frequently lead to stronger, more resilient, higher-impact portfolios. Find out how your 401(k) can become more sustainable and fossil-free at ',
          _react2.default.createElement(
            'a',
            { href: 'http://www.HIPinvestor.com', target: '_blank' },
            _react2.default.createElement(
              'strong',
              null,
              'www.HIPinvestor.com'
            )
          ),
          '.'
        )
      );
    };

    _this.renderReleaseLaunch = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'release-wrap' },
        _react2.default.createElement(
          'h3',
          null,
          'New Web Tool Reveals Fossil Fuel Companies Hidden in Mutual Funds'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'SEPTEMBER 15, 2015 \u2014'
          ),
          ' FossilFreeFunds.org was unveiled today by shareholder advocacy nonprofit As You Sow, using Morningstar fund holding data, in collaboration with Fossil Free Indexes, Carbon Tracker Initiative, BrightScope, and HIP investor. This new, free-to-the-public web tool reveals where fossil fuel holdings are hiding in 1,500 of the most-held mutual funds. Consumers are empowered to find where their money is invested and avoid the financial risk of a weak oil industry, align their investments with their values, and avoid supporting companies fueling climate change. '
        ),
        _react2.default.createElement(
          'p',
          null,
          'The five major fund families that control recordkeeping at 75% of all employer-sponsored retirement plans valued at $5.6 trillion for 91 million Americans, including Fidelity, Vanguard, and TIAA-CREF, do not offer any mutual funds that are socially responsibly, diversified, and free of the 200 companies with the largest oil, gas, and coal reserves (called the Carbon Underground 200',
          _react2.default.createElement(
            'sup',
            null,
            'TM'
          ),
          '), which is the minimum requirement of the ',
          _react2.default.createElement(
            'a',
            { href: 'http://divestinvest.org/individual', title: 'Divest-Invest Individual' },
            'Divest-Invest pledge'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'For investors wishing to more rigorously define \u201Cfossil free,\u201D screens for coal, fossil-fired utilities, and service companies like Halliburton are available. Funds that are clean of screened investments earn a green badge, with a maximum of five. Out of 1,500 funds with the highest plan count, only 12 diversified and SRI funds earned five badges, including Parnassus Endeavor (PARWX), Portfolio 21 Global Equity (PORTX), Brown Advisory Sustainable Growth (BAWAX), PAX World Growth (PXGAX), Green Century Balanced (GCBLX), Gabelli SRI (SRIGX), and Shelton Green Alpha (NEXTX). '
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u201CWe developed FossilFreeFunds.org after we realized our own 401(k) had funds holding oil, gas, and coal extraction companies \u2013 but we had no idea,\u201D said Andrew Behar, As You Sow\u2019s CEO. \u201CWe figured if we didn\u2019t know, then no one did. This tool gives everyone the power to know what they own, so they can own what they own.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'According to Joanna McGinley, Head of Global Alliances and Redistributor Solutions for Morningstar, \u201CWith comprehensive fund holdings data, we are able to provide greater transparency and help investors better evaluate the sustainable and ethical effect of their investments.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            '# # #'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Fossil Free Funds'
          ),
          ' - Fossil fuel investments carry real financial risks. With Fossil Free Funds, you can look up mutual funds and see their exposure to various fossil fuel companies. Brought to you by As You Sow, with financial data provided by Morningstar. For more information, visit ',
          _react2.default.createElement(
            'a',
            { href: 'https://fossilfreefunds.org' },
            _react2.default.createElement(
              'strong',
              null,
              'fossilfreefunds.org'
            )
          ),
          '.'
        )
      );
    };

    _this.state = {
      macroclimate: false,
      footprint: false,
      retirementPlans: false,
      launch: false
    };
    return _this;
  }

  (0, _createClass3.default)(Media, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Media';
      var description = 'Get your money out of fossil fuels. See press coverage of Fossil Free Funds.';
      var url = _config2.default.domain + _config2.default.routes.media;

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'top' }),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                title
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answers' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor', id: 'contact' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Get in touch'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    _react2.default.createElement(
                      _components.Link,
                      { to: _config2.default.links.contact, title: 'Contact', primarybutton: true },
                      _react2.default.createElement('i', { className: 'fa fa-envelope-o' }),
                      '\xA0\xA0\xA0Contact',
                      _react2.default.createElement(_components.LinkIcon, null)
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Media Inquiries'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Jill Courtenay, Communications Project Manager, As You Sow'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          xstrong: true,
                          styleName: 'contact',
                          to: _config2.default.links.contactJill,
                          title: 'Jill Courtenay, Communications Project Manager, As You Sow' },
                        'Email',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'strong',
                        null,
                        'General Inquiries'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Andrew Montes, Director of Digital Strategies, As You Sow'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          xstrong: true,
                          styleName: 'contact',
                          to: _config2.default.links.contactAndrew,
                          title: 'Email Andrew Montes, Director of Digital Strategies, As You Sow' },
                        'Email',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Press coverage'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    this.pressHits.map(function (pressHit, i) {
                      return _react2.default.createElement(
                        'div',
                        { key: i, styleName: 'press-item' },
                        _react2.default.createElement(
                          _components.Link,
                          {
                            to: pressHit.link,
                            title: pressHit.outlet + ' - ' + pressHit.headline },
                          _react2.default.createElement(
                            'div',
                            { styleName: 'press-item-outlet' },
                            pressHit.outlet
                          ),
                          _react2.default.createElement(
                            'div',
                            null,
                            pressHit.headline
                          )
                        )
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'answer' },
                  _react2.default.createElement('div', { styleName: 'anchor' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-title' },
                    'Media releases'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'answer-info' },
                    this.renderReleaseMacroclimateButton(),
                    this.renderReleaseFootprintButton(),
                    this.renderReleaseRetirementPlansButton(),
                    this.renderReleaseLaunchButton()
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(_components.AboutBanner, null)
            )
          )
        )
      );
    }
  }]);
  return Media;
}(_react.Component)) || _class);
exports.default = Media;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Media/Media.js
// module id = 1414
// module chunks = 0